import { CustomEmailDirective } from './custom-email.directive';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [CustomEmailDirective],
    imports: [CommonModule],
    exports: [CustomEmailDirective],
})
export class FiCustomEmailModule {}
